import { Box, Button, Theme, Typography } from "@mui/material";
import { useState } from "react";
import PortfolioHealth from "../tables/portfolioHealth";
import AssetAllocationCompliance from "../assetAllocationCompliance";

export interface ComplianceProps {
    clientCode: string;
    portfolioId: string;
}

export default function Compliance(props: ComplianceProps): JSX.Element {
    const { clientCode, portfolioId } = props;

    const [activeOuterTab, setActiveOuterTab] = useState<string>("Portfolio Health")

    const handleOuterTabChange = (activeTab: string) => {
        setActiveOuterTab(activeTab)
    }
    return (
        <Box
            sx={(theme: Theme) => ({
                borderRadius: "25px",
                padding: "35px",
                backgroundColor: theme.palette.common.white,
                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
            })}
        >
            {/* Tabs container */}
            <Box
                sx={{
                    display: 'flex',
                    gap: '10px',
                    marginBottom: '25px',
                }}
            >
                {/* Asset Allocation Compliance */}
                {["Portfolio Health", "Portfolio Compliance"].map((item) => {
                    return (
                        <Button
                            variant={activeOuterTab === item ? "contained" : "text"}
                            key={item}
                            onClick={() => handleOuterTabChange(item)}
                            sx={(theme: Theme) => ({
                                padding: '0px 15px',
                                background: activeOuterTab === item ? theme.palette.primary[500] : 'transparent',
                                borderRadius: '7px',
                                outline: 'none',
                                border: 'none',
                                cursor: 'pointer'
                            })}

                        >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: activeOuterTab === item ? theme.palette.textDark.primary : theme.palette.text.secondary
                                })}
                            >
                                {item}
                            </Typography>
                        </Button>
                    )
                })}
            </Box>

            <Box>
                {activeOuterTab === "Portfolio Health" &&
                    <PortfolioHealth
                        clientCode={clientCode}
                        portfolioId={portfolioId}
                    />}
                {/* Asset Allocation Compliance */}
                {activeOuterTab === "Portfolio Compliance" &&
                    <AssetAllocationCompliance
                        clientCode={clientCode}
                        portfolioId={portfolioId}
                    />}
            </Box>


        </Box>
    )
}